import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { CLIP_DURATION_LABEL, PLAYHEAD, PLAYHEAD_TIME } from './resultsMockData'

/** Mock 16:9 stimulus video with a glass controls bar. Static / no-op. */
export default function StimulusPlayer() {
  const theme = useTheme()
  const c = theme.affexy.colors

  return (
    <Box
      sx={{
        position: 'relative',
        bgcolor: c.navy900,
        borderRadius: '14px',
        overflow: 'hidden',
        aspectRatio: '16/9',
        boxShadow: '0 12px 32px -12px rgba(0,0,0,.3)',
      }}
    >
      <svg
        viewBox="0 0 800 450"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
      >
        <defs>
          <radialGradient id="r-spot" cx="50%" cy="40%" r="60%">
            <stop offset="0" stopColor={c.coral300} stopOpacity=".4" />
            <stop offset="1" stopColor={c.coral300} stopOpacity="0" />
          </radialGradient>
        </defs>
        <rect width="800" height="450" fill={c.navy900} />
        <rect width="800" height="450" fill="url(#r-spot)" />
        <ellipse cx="400" cy="370" rx="220" ry="20" fill="rgba(0,0,0,.5)" />
        <g transform="translate(280,200)">
          <ellipse cx="60" cy="80" rx="50" ry="60" fill="#E8C9B4" />
          <path d="M30 40 Q60 10 90 40 Q90 80 60 90 Q30 80 30 40 Z" fill="#3A2A26" />
          <rect x="30" y="135" width="60" height="80" rx="14" fill={c.coral} />
        </g>
        <g transform="translate(430,210)">
          <ellipse cx="50" cy="70" rx="42" ry="52" fill="#E8C9B4" />
          <path d="M22 32 Q50 8 78 32 Q78 70 50 78 Q22 70 22 32 Z" fill={theme.affexy.emotion.sadness} />
          <rect x="22" y="118" width="56" height="70" rx="12" fill={c.coral300} />
        </g>
        <text x="400" y="420" textAnchor="middle" fontFamily={theme.affexy.fonts.heading} fontWeight="700" fontSize="22" fill="#fff" opacity=".9">
          Smakuje jak dom.
        </text>
        {Array.from({ length: 20 }).map((_, i) => (
          <circle key={i} cx={40 + ((i * 43) % 720)} cy={30 + ((i * 23) % 180)} r={(i % 3) + 1} fill={c.coral100} opacity=".35" />
        ))}
      </svg>

      <Box
        sx={{
          position: 'absolute',
          left: 14,
          right: 14,
          bottom: 14,
          px: 1.75,
          py: 1.25,
          bgcolor: 'rgba(11,11,28,.7)',
          backdropFilter: 'blur(14px)',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
        }}
      >
        <Box
          component="button"
          type="button"
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            bgcolor: c.coral,
            border: 'none',
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            flex: '0 0 32px',
          }}
        >
          <PlayArrowIcon sx={{ fontSize: 16, color: '#fff' }} />
        </Box>
        <Box component="span" sx={{ fontSize: 12, color: '#fff', fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
          {PLAYHEAD_TIME}
        </Box>
        <Box sx={{ flex: 1, height: 4, bgcolor: 'rgba(255,255,255,.2)', borderRadius: `${theme.affexy.radii.pill}px`, position: 'relative' }}>
          <Box sx={{ position: 'absolute', inset: 0, width: `${PLAYHEAD * 100}%`, bgcolor: '#fff', borderRadius: `${theme.affexy.radii.pill}px` }} />
          <Box
            sx={{
              position: 'absolute',
              left: `${PLAYHEAD * 100}%`,
              top: -3,
              width: 10,
              height: 10,
              borderRadius: '50%',
              bgcolor: '#fff',
              transform: 'translateX(-50%)',
            }}
          />
        </Box>
        <Box component="span" sx={{ fontSize: 12, color: 'rgba(255,255,255,.6)', fontVariantNumeric: 'tabular-nums' }}>
          {CLIP_DURATION_LABEL}
        </Box>
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            px: 1.25,
            py: 0.5,
            borderRadius: `${theme.affexy.radii.pill}px`,
            bgcolor: 'rgba(255,255,255,.1)',
            fontSize: 11,
            color: '#fff',
            fontWeight: 500,
          }}
        >
          1×
          <ExpandMoreIcon sx={{ fontSize: 13 }} />
        </Box>
      </Box>
    </Box>
  )
}
